import { queryOptions } from '@tanstack/react-query';

import type { CustomerInfo } from '@/integrations/revenuecat/types';

import { getCustomerInfo } from './getCustomerInfo';

export const getCustomerInfoQueryKey = () =>
  ['revenuecat', 'customerInfo'] as const;

export const customerInfoOptions = <T = CustomerInfo | null>() =>
  queryOptions<CustomerInfo | null, unknown, T>({
    queryKey: getCustomerInfoQueryKey(),
    queryFn: getCustomerInfo,
    staleTime: 30_000,
  });
